import React from "react";

export default function HeroVideo() {
  return (
    <video
      src="/banner4.mp4"
      className="hero-banner-video"
      autoPlay
      loop
      muted
      playsInline
      preload="auto"
      aria-label="Ego Blockchain"
      style={{
        position: "absolute",
        inset: 0,
        width: "100%",
        height: "100%",
        objectFit: "cover",
      }}
    />
  );
}
